import React from 'react';

export const Exit = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5039 10.3735C12.9181 10.3735 13.2539 10.7093 13.2539 11.1235V12.8763C13.2539 13.2905 12.9181 13.6263 12.5039 13.6263C12.0897 13.6263 11.7539 13.2905 11.7539 12.8763V11.1235C11.7539 10.7093 12.0897 10.3735 12.5039 10.3735Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5004 3.54101C11.3098 3.29389 10.1938 4.20228 10.1938 5.41568V18.5843C10.1938 19.7977 11.3098 20.7061 12.5004 20.459L17.7232 19.375C18.6129 19.1903 19.25 18.4073 19.25 17.5003V6.49969C19.25 5.59273 18.6129 4.80968 17.7232 4.62502L12.5004 3.54101ZM8.69385 5.41568C8.69385 3.24987 10.6848 1.63221 12.8053 2.07232L18.0281 3.15633C19.6131 3.4853 20.75 4.88104 20.75 6.49969V17.5003C20.75 19.119 19.6131 20.5147 18.0281 20.8437L12.8053 21.9277C10.6848 22.3678 8.69385 20.7502 8.69385 18.5843V5.41568Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 7.32677C3.25 5.55808 4.68472 4.12524 6.45336 4.12524H9.30548C9.71969 4.12524 10.0555 4.46103 10.0555 4.87524C10.0555 5.28946 9.71969 5.62524 9.30548 5.62524H6.45336C5.51209 5.62524 4.75 6.38757 4.75 7.32677V16.6731C4.75 17.6123 5.51209 18.3746 6.45336 18.3746H9.30548C9.71969 18.3746 10.0555 18.7104 10.0555 19.1246C10.0555 19.5388 9.71969 19.8746 9.30548 19.8746H6.45336C4.68472 19.8746 3.25 18.4418 3.25 16.6731V7.32677Z"
      fill="#64748B"
    />
  </svg>
);
